import * as Types from './appTypes';

export const setCurrentSurvey = survey => ({
  type: Types.SET_CURRENT_SURVEY,
  payload: {
    survey
  }
});

export const setShowLoginModal = status => ({
  type: status
});

export const setAnonymousUser = () => ({
  type: Types.SET_ANONYMOUS_USER
});

export const setLoading = loading => ({
  type: Types.SET_LOADING,
  payload: {
    loading
  }
});
